import { actions } from './actions'
import { mutations } from './mutations'

export const genesys = {
  namespaced: true,
  state: {
    areScriptsLoaded: false,
    buttonIsVisible: false,
  },
  getters: {
    areScriptsLoaded: (state) => state.areScriptsLoaded,
    buttonIsVisible: (state) => state.buttonIsVisible,
  },
  mutations,
  actions,
}
